import Vue from 'vue';
import axios from 'axios';
import router from './router'
import COS from 'cos-js-sdk-v5'
import store from './store/index'

/* 后端api地址 */
Vue.prototype.ApiUrl = process.env.NODE_ENV == 'development' ? 'http://api.xl.cc/index.php' :
  'https://xl.sz90.cn/index.php';
// Vue.prototype.ApiUrl = 'https://private.xl.sz90.cn//index.php';
// Vue.prototype.ApiUrl = 'https://cs.xl.sz90.cn/index.php';
// Vue.prototype.ApiUrl = 'https://zhyl.xckj2012.com/index.php'; //愚人文化
// Vue.prototype.ApiUrl = 'https://www.yuanzhenjk.cn/index.php'; //元贞健康
// Vue.prototype.ApiUrl = 'https://djk.wansenhanfang.com/index.php'; //杭州朝帮网络信息技术有限公司
// Vue.prototype.ApiUrl = 'https://yky.hlwjrd.com/index.php'; //卓云健康空间
// Vue.prototype.ApiUrl = 'https://yikang.vetui.cn/index.php'; //易健康管理
// Vue.prototype.ApiUrl = 'https://yuanzhen.vendingos.com/index.php'  //元贞测试
// Vue.prototype.ApiUrl = 'https://iot.csjjk.com/index.php' //海猴子
// Vue.prototype.ApiUrl = 'https://zyy.zh12349.com/index.php' //中科养老
// Vue.prototype.ApiUrl = 'https://private.xl.sz90.cn/index.php'  //清补
Vue.prototype.ApiUrl = 'https://adm.api.sz90.cn/index.php' //寻疗
// Vue.prototype.ApiUrl = 'https://huishanyoudao.mingdaotang.com/index.php'  //汇善有道
// Vue.prototype.ApiUrl = 'https://ky.tianlunshiguang.com/index.php' //天伦时光
// Vue.prototype.ApiUrl = 'https://iot.airukang.cn/index.php' //爱如康
/* 图片地址 */
// Vue.prototype.ImgUrl = 'https://xl.sz90.cn';
// Vue.prototype.ImgUrl = 'http://api.xl.cc';
Vue.prototype.ImgUrl = 'https://adm.api.sz90.cn/';
// Vue.prototype.ImgUrl = 'https://private.xl.sz90.cn/';
// Vue.prototype.ImgUrl = 'https://cs.xl.sz90.cn';
// Vue.prototype.ImgUrl = 'https://zhyl.xckj2012.com'; //愚人文化
// Vue.prototype.ImgUrl = 'https://www.yuanzhenjk.cn'; //元贞健康
// Vue.prototype.ImgUrl = 'https://djk.wansenhanfang.com'; //杭州朝帮网络信息技术有限公司
// Vue.prototype.ImgUrl = 'https://yky.hlwjrd.com'; //卓云健康空间
// Vue.prototype.ImgUrl = 'https://yikang.vetui.cn'; //易健康管理
// Vue.prototype.ImgUrl = 'https://yuanzhen.vendingos.com'
// Vue.prototype.ImgUrl = 'https://iot.csjjk.com' //海猴子
// Vue.prototype.ImgUrl = 'https://huishanyoudao.mingdaotang.com'  //寻疗
// Vue.prototype.ImgUrl = 'https://zyy.zh12349.com' //中科养老
// Vue.prototype.ImgUrl = 'https://private.xl.sz90.cn'  //清补
// Vue.prototype.ImgUrl = 'https://huishanyoudao.mingdaotang.com'  //寻疗
// Vue.prototype.ImgUrl = 'https://ky.tianlunshiguang.com' //天伦时光
/* 总后台api地址*/
Vue.prototype.totalUrl = 'https://total.api.sz90.cn'
/* 云端api地址 */
// Vue.prototype.CloudUrl = 'https://api.cloud.sz90.cn/index.php';
Vue.prototype.CloudUrl = 'http://api.xlcloud.cc/index.php';
/* 前端域名 */
Vue.prototype.FrontUrl = 'https://account.sz90.cn';
// Vue.prototype.FrontUrl = 'https://zyy.zh12349.com'
// Vue.prototype.FrontUrl = 'https://zhyl.xckj2012.com'; //愚人文化
// Vue.prototype.FrontUrl = 'https://www.yuanzhenjk.com'; //元贞健康
// Vue.prototype.FrontUrl = 'https://djk.wansenhanfang.com'; //杭州朝帮网络信息技术有限公司
// Vue.prototype.FrontUrl = 'https://yky.hlwjrd.com'; //卓云健康空间
// Vue.prototype.FrontUrl = 'https://yikang.vetui.cn'; //易健康管理
/* 商户ID */
Vue.prototype.Store_id = store.state.apply_info.store_id || store.state.admin.store_id;
/* MQTT连接地址 */
// Vue.prototype.MqttUrl = "ws://127.0.0.1:8083/mqtt"
Vue.prototype.MqttUrl = "wss://cs.cloud.sz90.cn/websocket/"
// =============== 私有部署 start
require('./assets/js/private.js');
// =============== 私有部署 end

/*
  路由跳转 url 跳转路由地址 string 必须 query 额外参数 object 可选
 */
Vue.prototype.toUrl = function(url, query) {
  if (!url) return false
  const queryParams = {
    ...query
  }
  this.$router.push({
    path: '/admin' + url,
    query: queryParams
  });
}
// 发送腾讯云对象存储
function CosPutObject(SecretId, SecretKey, Bucket, fileObject, _this) {
  return new Promise((resolve) => {
    var cos = new COS({
      SecretId: SecretId,
      SecretKey: SecretKey
    })
    cos.putObject({
      Bucket: Bucket,
      Region: 'ap-nanjing',
      Key: 'store_id_' + JSON.parse(localStorage.getItem('userInfo')).store_id + '/' + Date.parse(
        new Date()),
      Body: fileObject,
      onProgress: function(progressData) {
        console.log(JSON.stringify(progressData));
      }
    }, function(err, data) {
      if (err) return _this.alertErr(err)
      resolve({
        pic_url: data.Location
      })
    })
  })
}

//腾讯云-云存储
Vue.prototype.putObject = function(fileObject) {
  let _this = this
  return new Promise((resolve) => {
    let SecretId = 'AKIDNoInIiR5e7Wp2BILKF7woeSIC5udGoIh'
    let SecretKey = 'OfqJh0CINORVafi0HVgpuxOpFd0JZp4J'
    let Bucket = 'xunliao-1-1257941115'
    //获取腾讯云对象存储key跟id
    if (store.state.apply_info.id) {
      let formData = new FormData()
      formData.append('file', fileObject)
      this.requestApi('/adm/get_tenxuyun_secret').then(
        (res) => {
          if (res.code == 200) {
            //私有化未开启腾讯云存储
            if (res.data.storage_type == undefined || res.data.storage_type == 'undefined' || res.data
              .storage_type == 1) {
              _this.requestApi('/adm/upload_object', formData, {
                'content-Type': 'multipart/form-data'
              }, true).then(
                (ress) => {
                  if (ress.status == 1) {
                    resolve({
                      pic_url: ress.pic_url
                    })
                  } else {
                    return _this.alertErr(ress.msg)
                  }
                }
              )
            } else {
              if (!res.data.tencent_cloud_key || !res.data.tencent_cloud_secret || !res.data
                .tencent_cloud_bucket) return _this.alertErr('请配置腾讯云对象存储密钥')
              SecretId = res.data.tencent_cloud_key
              SecretKey = res.data.tencent_cloud_secret
              Bucket = res.data.tencent_cloud_bucket
              CosPutObject(SecretId, SecretKey, Bucket, fileObject, _this).then((res) => {
                resolve(res)
              })
            }
          } else {
            return _this.alertErr(res.msg)
          }
        }
      )
    } else {
      CosPutObject(SecretId, SecretKey, Bucket, fileObject, _this).then((res) => {
        resolve(res)
      })
    }
  })
}

/*
  url 请求地址 string 必须
  data 请求参数 object 可选
  headers 请求头 默认不需要传值
 */
Vue.prototype.requestApi = function(url, data = {}, headers = '', is_file = false) {
  if (!is_file) {
    var datas = {}
    datas.data = data || {}
  } else {
    datas = data
  }
  if (this.$route.path.indexOf('/admin/clinic/') != -1 && this.$route.path.indexOf('/admin/clinic/outpatient') == -
    1) {
    let clinic_info = JSON.parse(localStorage.getItem('SYSTEM_CLINIC'))
    if (clinic_info && clinic_info.token != localStorage.getItem('token')) {
      return false
    }
  }
  datas.apply_id = store.state.apply_info.id || 0
  let header = Object.assign({
    'content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }, headers);
  return new Promise((resolve) => {
    axios.interceptors.request.use(
      config => {
        const token = this.getToken();
        token && (config.headers.authorize = token);
        // // 私有部署应用store_id-数据
        // // 关闭浏览器或退出需要移除APP_STORE_ID，否则下次登录等请求自动带上
        if (localStorage.getItem('store_type') == 1 &&
          sessionStorage.getItem('APP_STORE_ID') != null) {
          config.headers.appstoreid = sessionStorage.getItem('APP_STORE_ID');
        }

        return config;
      }, error => {
        return Promise.error(error);
      });
    axios({
      method: typeof datas == "object" ? 'POST' : 'GET',
      url: this.ApiUrl + url,
      data: datas,
      headers: header,
      responseType: 'json',
    }).then(res => {
      if (res.status == 200) {
        if (res.data.status == 403) {
          this.alertErr(res.data.msg);
        } else if (res.data.status == 401) {
          const store_type = this.$store.state.store_type
          if (store_type == 0) {

          } else if (store_type == 3) {
            if (this.$store.state.admin.store_id) {
              this.toUrl('/clinic/login/' + this.$store.state.admin.store_id)
            }
          } else if (store_type == 4) {
            if (this.$store.state.admin.store_id) {
              this.toUrl('/mechanism/login/' + this.$store.state.admin.store_id)
            }
          } else {
            localStorage.removeItem('SYSTEM_SAAS_OR_APP')
            this.toUrl('/login')
          }
          localStorage.removeItem('token')
          this.alertErr(res.data.msg)
        } else {
          resolve(res.data);
        }
      }
    }).catch(err => {
      this.alertErr('请求失败！', 4.5)
    })
  })
}
/* 获取token */
var delay_status = 0;
var out_time = 43200;
Vue.prototype.getToken = function() {
  //根据不同的路由获取不同的token
  var urlPath = window.location.pathname
  if (urlPath.indexOf('/admin/clinic/') != -1 && urlPath.indexOf('/admin/clinic/outpatient/') == -1) {
    var token = JSON.parse(localStorage.getItem('SYSTEM_CLINIC'))
  } else if (urlPath.indexOf('/admin/store_') != -1 && window.location.href.indexOf(
      '/admin/store_member/goods/edit?type=1') == -1) {
    var token = JSON.parse(localStorage.getItem('SYSTEM_STORE'))
  } else if (urlPath.indexOf('/admin/private/') != -1) {
    var token = JSON.parse(localStorage.getItem('SYSTEM_ADMIN'))
  } else if (urlPath.indexOf('/admin/mechanism/') != -1 || urlPath.indexOf('/device/mechanism_device_home') != -1) {
    var token = JSON.parse(localStorage.getItem('SYSTEM_MECHANISM'))
  } else {
    var token = JSON.parse(localStorage.getItem('SYSTEM_SAAS_OR_APP'))
  }
  if (token) {
    token = token.token
  } else {
    token = localStorage.getItem('token')
  }
  if (token && !delay_status) {
    let aout_time = localStorage.getItem('aout_time'),
      now = new Date().getTime();
    now = parseInt(now.toString().substr(0, 10));
    if (!aout_time || (aout_time - now) < (out_time - 600)) {
      delay_status = 1;
      var apiurl = this.$store.state.store_type == 1 ? '/adm/delay' : this.$store.state.store_type == 3 ?
        '/clinic/delay' : '/store/delay'
      this.requestApi(apiurl).then(function(res) {
        if (res.status == 1) {
          localStorage.setItem('aout_time', res.out_time);
          delay_status = 0;
        } else {
          delay_status = 0;
        }
      })
    }
  }
  return token;
}
Vue.prototype.alertSucc = function(txt, duration) {
  this.$Message.success({
    content: txt,
    background: true,
    duration: duration ? duration : 2
  })
}
/* 全局错误消息提醒 */
Vue.prototype.alertErr = function(txt, duration) {
  this.$Message.error({
    content: txt,
    background: true,
    duration: duration ? duration : 2
  })
}
Vue.prototype.getDateTime = function(date, type = true) {
  date = typeof date != "undefined" ? date : new Date();
  var y = date.getFullYear(),
    m = sendDate(date.getMonth() + 1),
    d = date.getDate(),
    h = sendDate(date.getHours()),
    i = sendDate(date.getMinutes()),
    s = sendDate(date.getSeconds());
  if (type) date = y + '-' + m + '-' + d + ' ' + h + ':' + i + ':' + s
  else date = y + '-' + m + '-' + d
  return date
}

//根据日期计算月份
Vue.prototype.getMonthTime = function(strDate) {
  var date = new Date();
  let Y = date.getFullYear();
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var currentMonth = strDate.substr(5, 2)
  var month = M - currentMonth ? M - currentMonth : 1
  if (month < 0) month = 12 - (currentMonth - M)
  return month
}
// 根据日期计算年龄
Vue.prototype.getAge = function(strBirthday) {
  //strBirthday传入格式 2020-04-15
  var returnAge;
  var strBirthdayArr = strBirthday.split('-');
  var birthYear = strBirthdayArr[0];
  var birthMonth = strBirthdayArr[1];
  var birthDay = strBirthdayArr[2];
  //获取当前日期
  var d = new Date();
  var nowYear = d.getFullYear();
  var nowMonth = d.getMonth() + 1;
  var nowDay = d.getDate();
  if (nowYear == birthYear) {
    returnAge = 0; //同年 则为0岁
  } else {
    var ageDiff = nowYear - birthYear; //年之差
    if (ageDiff > 0) {
      if (nowMonth == birthMonth) {
        var dayDiff = nowDay - birthDay; //日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      } else {
        var monthDiff = nowMonth - birthMonth; //月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      }
    } else {
      returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
    }
  }
  return returnAge; //返回周岁年龄
}

Vue.prototype.dateToAge = function(date) {
  //出生年-月-日
  let Dates = new Date(date)
  //当前年-月-日
  let now_date = new Date()
  //生日-年
  let year = Dates.getFullYear()
  //生日-月
  let month = Dates.getMonth() + 1
  //当前年份
  let current_year = now_date.getFullYear();
  //当前月份
  let current_month = now_date.getMonth() + 1;
  //当前年份减去生日年份
  let count_year = current_year - year;
  //当前月份减去生日月份
  let count_month = current_month - month;
  if (count_year <= 3) {
    if (count_month < 0) {
      count_year--;
      count_month = (current_month + 12) - month;
    }
    let age = count_year * 12 + count_month ? count_year * 12 + count_month : 1;
    return age + '个月';
  } else {
    if (count_month < 0) {
      count_year--;
    }
    return count_year + '岁';
  }
}

function sendDate(d) {
  if (parseInt(d) < 10) {
    d = '0' + d;
  }
  return d;
}

//复制文本
Vue.prototype.copyText = function(text) {
  return new Promise((success, error) => {
    let target = document.createElement('input')
    target.value = text;
    document.body.appendChild(target)
    target.select()
    document.execCommand('Copy')
    success(text)
  })
}
//下载图片
Vue.prototype.downloadIamge = function(url, file_name) {
  var image = new Image()
  image.setAttribute("crossOrigin", "anonymous")
  image.onload = function() {
    var canvas = document.createElement("canvas")
    canvas.width = image.width
    canvas.height = image.height
    var context = canvas.getContext("2d")
    context.drawImage(image, 0, 0, image.width, image.height)
    var url = canvas.toDataURL("image/png") //得到图片的base64编码数据
    var a = document.createElement("a") // 生成一个a元素
    var event = new MouseEvent("click") // 创建一个单击事件
    a.download = file_name || "photo" // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
  }
  image.src = url
}

// 获取完整的图片地址
Vue.prototype.fullImage = function(img) {
  // 检测传递的图片地址为空
  if (!img) return '';
  var image = img;
  if (img.indexOf('http') < 0) {
    image = img.indexOf('/uploads') != -1 || img.indexOf('/image') != -1 ? this.ImgUrl + img : 'https://' + img;
  }
  return image;
}


//判断当前页面是在哪个端
Vue.prototype.isStoreType = function(type) {
  if (this.$store.state.store_type == type) return true
  else return false
}



// WEBPACK FOOTER //
// ./src/comfun.js